/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/A2/components/A2CarbonSummary.tsx.
 */

import React from "react";
import { EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL } from "../../shared/contributorFieldDisplayLabels";

interface Props {
  /** Sum of per–raw-material transport embodied carbon (reference qty column). */
  totalKgCo2e: number;
  /** Total ÷ background finished declared qty when available. */
  perFinishedKgCo2e?: number | null;
  /** Unit for per-finished qty (from Background finished material unit). */
  perFinishedUnitLabel?: string;
}

const A2CarbonSummary: React.FC<Props> = ({
  totalKgCo2e,
  perFinishedKgCo2e,
  perFinishedUnitLabel = "kg CO₂e per finished qty",
}) => {
  return (
    <div className="embodied-carbon-summary-container a2-derived-summary">
      <div className="ecs-row">
        <div className="ecs-col ecs-col-left">
          <label className="ecs-label">
            Embodied carbon — transport (A2), all raw materials
          </label>
          <input readOnly value={String(totalKgCo2e)} className="ecs-input" />
        </div>
        <div className="ecs-col ecs-col-right">
          <label className="ecs-label">Unit</label>
          <input readOnly value="kg CO₂e" className="ecs-input" />
        </div>
      </div>
      {perFinishedKgCo2e != null && Number.isFinite(perFinishedKgCo2e) ? (
        <div className="ecs-row ecs-row-secondary">
          <div className="ecs-col ecs-col-left">
            <label className="ecs-label">
              {EMBODIED_CARBON_PER_FUNCTIONAL_UNIT_LABEL}
            </label>
            <input
              readOnly
              value={String(perFinishedKgCo2e)}
              className="ecs-input"
            />
          </div>
          <div className="ecs-col ecs-col-right">
            <label className="ecs-label">Unit</label>
            <input
              readOnly
              value={perFinishedUnitLabel}
              className="ecs-input"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

/** React component — A2Carbon Summary. */
export default A2CarbonSummary;
